import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filterUrl: String, artistUrl: String, refreshUrl: String, scrolling: Boolean }
  static classes = ["loading", "success", "error"]

  static get targets() {
    return ["ignored", "entries", "loader", "uploader", "list", "pagination", "ignored", "name"]
  }

  connect() {
  }

  scroll() {
    let nextPage = this.paginationTarget.querySelector("a[aria-label='Next']")

    if (nextPage == null) {
      return
    }

    let url = nextPage.href
    if (url == "") {
      return
    }

    let body = document.body,
    html = document.documentElement
    let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    if (window.pageYOffset >= height - window.innerHeight - 100) {
      if (this.scrolling === true) {
        return;
      }

      this.scrolling = true;
      this.loadMore(url);
    }
  }

  filter(){
    const nameValue = this.nameTarget.value;
    const ignoredValue = this.ignoredTarget.checked;
    console.log(`nameValue = ${nameValue}; ignoredValue = ${ignoredValue}`);

    fetch(this.filterUrlValue + '?' + $.param({ "filters": { "ignored": ignoredValue, "name": nameValue } }),
      {
        method: 'GET',
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content
        }
      }
    )
    .then(response => response.json())
    .then((data) => {
      this.listTarget.innerHTML = data.entries;
      this.paginationTarget.innerHTML = data.pagination
      this.scrolling = false;
    })
  }

  loadMore(url) {
    fetch(url,
      {
        method: 'GET',
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content
        }
      }
    )
    .then(response => response.json())
    .then((data) => {
      this.listTarget.insertAdjacentHTML('beforeend', data.entries)
      this.paginationTarget.innerHTML = data.pagination
      this.scrolling = false;
    })
  }

  upload() {
    const entriesValue = this.entriesTarget.value;

    this.uploaderTarget.classList.add(this.loadingClass);
    this.uploaderTarget.innerHTML = 'updating, please wait...';

    if (entriesValue === '' || entriesValue === undefined) {
      this.uploaderTarget.innerHTML = '';
      return;
    }

    fetch(
      `${this.refreshUrlValue}.json`,
      {
        body: JSON.stringify({ entries: entriesValue }),
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content
        }
      }
    )
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network error');
      }
      
      return response.text();
    })
    .then(res => {
      this.uploaderTarget.innerHTML = 'updated!';
      this.uploaderTarget.classList.add(this.successClass);
      this.entriesTarget.value = '';
    })
    .catch(error => {
      this.uploaderTarget.innerHTML = 'failed!';
      this.uploaderTarget.classList.add(this.errorClass);
    })
  }

  ignore() {
    const ignoredValue = this.ignoredTarget.value

    this.loaderTarget.innerHTML = `updating...`;

    fetch(
      `${this.artistUrlValue}.json`,
      {
        body: JSON.stringify({ ignored: ignoredValue }),
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content
        }
      }
    )
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network error');
      }

      return response.text();
    })
    .then(res => {
      this.loaderTarget.innerHTML = '';
    })
    .catch(error => {
      this.loaderTarget.innerHTML = 'failed!';
    })
  }
}
